import { showAlert } from "../alert/alertActions";
import { showLoader, hideLoader } from "../loader/loaderActions";
import Api from "../../service/api";
import { history, getState } from "../configure/configureStore";
import { actionTypes } from "./userManagementReducer";
import {
  resetPageAndLimit,
  resetSearchFilters,
  resetActiveNavigationTab,
  resetSearchFilterForVideosByUrl,
} from "../YouTubeManagement/YouTubeManagementActions";

export function getUserList(data, page, limit) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.GET_USER_LIST_PENDING,
      payload: {
        getUserListPending: true,
        getUserListSuccess: false,
        getUserListError: null,
        userList: null,
      },
    });
    dispatch(showLoader());

    Api.post(`auth/fetchUserList?page=${page}&limit=${limit}`, data)
      .then((response) => {
        // console.log(response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_USER_LIST_SUCCESS,
          payload: {
            getUserListPending: false,
            getUserListSuccess: true,
            getUserListError: null,
            userList: response.data,
            currentPage: response.data?.page,
            rowsPerPage: {
              label: `${response?.data?.limit}`,
              value: response?.data?.limit,
            },
          },
        });
        dispatch(resetPageAndLimit());
        dispatch(resetSearchFilters());
        dispatch(resetActiveNavigationTab());
        dispatch(resetSearchFilterForVideosByUrl());
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.GET_USER_LIST_ERROR,
          payload: {
            getUserListPending: false,
            getUserListSuccess: false,
            getUserListError: null,
            userList: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to fetch Users",
          })
        );
      });
  };
}

export function addUser(
  data,
  searchValueState,
  callback,
  callback2,
  callback3
) {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_NEW_USER_PENDING,
      payload: {
        addNewUserPending: true,
        addNewUserSuccess: false,
        addNewUserError: null,
      },
    });
    dispatch(showLoader());

    Api.post("auth/addUser", data)
      .then((response) => {
        console.log("add user", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_NEW_USER_SUCCESS,
          payload: {
            addNewUserPending: false,
            addNewUserSuccess: true,
            addNewUserError: null,
            searchValue: searchValueState,
          },
        });
        // dispatch(getUserList());
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: "Added new User",
          })
        );
        callback();
        callback2();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.ADD_NEW_USER_ERROR,
          payload: {
            addNewUserPending: false,
            addNewUserSuccess: false,
            addNewUserError: null,
          },
        });
        if (err.message === "Failed! User email is already in use!") {
          callback3();
        } else {
          dispatch(
            showAlert({
              isOpen: true,
              title: "Error",
              type: "danger",
              msg: err.message,
            })
          );
        }
      });
  };
}

export function editUser(
  id,
  data,
  searchValueState,
  callback,
  callback2,
  callback3
) {
  // console.log("hi");
  return (dispatch) => {
    dispatch({
      type: actionTypes.EDIT_USER_PENDING,
      payload: {
        editUserPending: true,
        editUserSuccess: false,
        editUserError: null,
      },
    });
    dispatch(showLoader());

    Api.put(`auth/updateUser/${id}`, data)
      .then((response) => {
        console.log("edit user", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.EDIT_USER_SUCCESS,
          payload: {
            editUserPending: false,
            editUserSuccess: true,
            editUserError: null,
            searchValue: searchValueState,
          },
        });
        // dispatch(getUserList());
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: "User updated",
          })
        );
        callback();
        callback2();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.EDIT_USER_ERROR,
          payload: {
            editUserPending: false,
            editUserSuccess: false,
            editUserError: null,
          },
        });
        if (err.message === "Failed! User email is already in use!") {
          callback3();
        } else {
          dispatch(
            showAlert({
              isOpen: true,
              title: "Error",
              type: "danger",
              msg: err.message,
            })
          );
        }
      });
  };
}
export function deleteUser(id, searchValueState, callback) {
  console.log(id);
  return (dispatch) => {
    dispatch({
      type: actionTypes.DELETE_USER_PENDING,
      payload: {
        deleteUserPending: true,
        deleteUserSuccess: false,
        deleteUserError: null,
      },
    });
    dispatch(showLoader());

    Api.put(`auth/deleteUser/${id}`)
      .then((response) => {
        console.log("delete user", response);
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.DELETE_USER_SUCCESS,
          payload: {
            deleteUserPending: false,
            deleteUserSuccess: true,
            deleteUserError: null,
            searchValue: searchValueState,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: "User deleted successfully",
          })
        );
        // dispatch(getUserList());
        callback();
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.DELETE_USER_ERROR,
          payload: {
            deleteUserPending: false,
            deleteUserSuccess: false,
            deleteUserError: null,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "Error",
            type: "danger",
            msg: "Failed to delete User",
          })
        );
      });
  };
}

export function updateRowsPerPage(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_ROWS_PER_PAGE,
      payload: {
        rowsPerPage: data,
      },
    });
  };
}

export function updateCurrentPage(page) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_CURRENT_PAGE,
      payload: {
        currentPage: page,
      },
    });
  };
}

export function updateSearchFilters(data) {
  return (dispatch) => {
    dispatch({
      type: actionTypes?.UPDATE_ADMIN_SEARCH_FILTERS,
      payload: {
        fields: data,
      },
    });
  };
}
